module.exports = __webpack_public_path__ + "img/10.2ad12acd.jpg";